// ref: https://stackoverflow.com/a/31044073
export const xor = (a: boolean, b: boolean) => {
  const result = Boolean(a) !== Boolean(b);
  return result;
};
